var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h3',[_vm._v("Dropdown 选择框")]),_vm._v(" "),_c('div',{staticClass:"j-row"},[_c('div',{staticClass:"j-col"},[_c('card',{attrs:{"meta":"Base"}},[_c('j-dropdown',{attrs:{"options":[{
            label: 'female',
            value: 0
            },{
            label: 'male',
            value: 1
          }]}}),_vm._v(" "),_c('template',{slot:"meta"},[_vm._v("\n          Base usage\n        ")]),_vm._v(" "),_c('template',{slot:"code"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.example1)}})])],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69221c1f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dropdown.vue
// module id = mmQo
// module chunks = 1